import { render, staticRenderFns } from "./PopupSkillSave.vue?vue&type=template&id=339fba2f&scoped=true"
import script from "./PopupSkillSave.vue?vue&type=script&lang=js"
export * from "./PopupSkillSave.vue?vue&type=script&lang=js"
import style0 from "./PopupSkillSave.vue?vue&type=style&index=0&id=339fba2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339fba2f",
  null
  
)

export default component.exports